import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TextField from '@material-ui/core/TextField';
import ModalTheme from '../../../../../shared/components/Modal';
import { faVial, faStethoscope, faNotesMedical, faHospitalUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ProceduresModal from './modalsQuickServices/ProceduresModal';
import LabsModal from './modalsQuickServices/LabsModal';
import ConsulationModal from './modalsQuickServices/ConsulationModal';
import { data } from 'jquery';
import SearchModalCUPS from '../../../../SearchModals/CUPS/SearchModalCUPS';
import SearchModalMedicines from '../../../../SearchModals/Medicines/SearchModalMedicines';
import MedicalIncapacity from '../MedicalIncapacity/MedicalIncapacity';
import pdfYodo from '../../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfYodo';
import { Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { calculateAgeParse } from '../../../../Utils/Patient';


const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const Header = ({ column }) => (
  <span className="react-table__column-header">
    <span>
      {column}
    </span>
  </span>
);

class MedicalOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      codigo: "",
      data: [],
      observation: "",
      formulas: [],
      medicationsObservations: "",
      dataDiagnostic: [],
      addedDiagnostics: [],
      observations: [],
      amount: [],
      loadAddedDiagnostics: false,
      openModal: false,
      load: false,
      countDiagnostic: 0,
      openMedicaments: false,
      loadMedicaments: false,
      dataMedicaments: [],
      medicament: [],
      principioactivo: '',
      cantidad: '',
      formafarmaceutica: '',
      viaadministracion: '',
      total: 0,
      dosis: '',
      frequence: '',
      frequenceVal: 0,
      duration: 0,
      cantidadMedicamentes: '',
      modalOpen: false,
      modalProcedures: false,
      proceduresList: [],
      modalConsult: false,
      consultList: [],
      modalLabs: false,
      labList: [],
      dataToTableFormula: /* this.props.MedicalOrders.formulas */[],
      modalIncapacity: false,
      modalYodo: false,
      infoPaciente: null,
      urlLogo: sessionStorage.getItem('logoURL'),
      profile: [],
      admissions: [],
      bloodType: '',
      medicoApoyo: null,
      firmDoctorGet: null,
      firmDoctorSupport: []
    };

  }
  //
  componentDidMount() {
    //console.log(this.props.MedicalOrders);
    //this.loadDiagnostic();
    /*this.setState({ load: true }, ()=>{
      this.props.loadMedicalOrders().then((load) => {
        this.setState({ load: load },()=>{
            console.log("cargar terminada !!");
        });
      }).catch((error)=>{
        console.log(error)
      });
    }) */

    this.loadCups();
    this.loadDataProfile();
    this.loadDataCita();
    this.getClinicHistory();
   

  }

  /*  componentDidUpdate(prevProps) {
     if (prevProps.MedicalOrders !== this.props.MedicalOrders) {
       //this.setState({ dataToTableFormula: this.props.MedicalOrders.formulas })
       this.changeFormulaList();
     }
   } */

  getClinicHistory = async () => {
    let id_historia = parseInt(this.props.id_historia);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/historia_clinica/' + id_historia, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({ admissions: data.admisiones });

      })
      .catch((error) => {
        alert(error);
        console.error('Error:', error);
      });
  }

  loadCups = () => {
    let proced = [], consul = [], labs = [];
    fetch(process.env.REACT_APP_PUBLIC_URL + 'servicio-acceso-rapido/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {

        for (let obj of data) {
          obj.tipo === 1 ? labs.unshift(obj) :
            obj.tipo === 2 ? consul.unshift(obj) :
              proced.unshift(obj)
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    console.log(proced);
    this.setState({ proceduresList: proced, consultList: consul, labList: labs });
  }

  loadDataProfile = async () => {

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log("CLINICA2", data);
        if (data.length > 0) {
          this.setState({
            profile: data[0],
            //urlLogo: process.env.REACT_APP_PUBLIC_URL + "clinica/" + data[0].id_clinica + "/logo/" + sessionStorage.getItem('token')
          })
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataCita = async () => {
    var data = { id_cita: this.props.data.id_cita };
    //id_agenda: this.props.dataEvent.id_agenda 
    //console.log(data);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultarpaciente', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.existe) {
          this.setState({ infoPaciente: data.contenido })
          this.setState({ idPlan: data.contenido.idPlan })
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataFirm = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar-firmas?id_admision=' + this.state.infoPaciente.admision.id_admision, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },

    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.firmas != null && data.firmas != undefined) {
        let url_doctor = process.env.REACT_APP_PUBLIC_URL + data.firmas.url_firma_doctor + '/' + sessionStorage.getItem('token');
        let url_tecnologo = process.env.REACT_APP_PUBLIC_URL + data.firmas.url_tecnologo + '/' + sessionStorage.getItem('token');
        let firmDoctorSupportGet = data.firmas.medico_apoyo.map(medico => {
          return process.env.REACT_APP_PUBLIC_URL + medico.url_firma_doctor_alter + '/' + sessionStorage.getItem('token');
        });
        this.setState({
          //firmTech: url_tecnologo,
          firmDoctor: url_doctor,
          //fullnameDoctor: data.firmas.nombre_doctor,
          //fullnameTech: data.firmas.tecnologo_nombre,
          medicoApoyo: data.firmas.medico_apoyo,
          //firmDoctorGet: data.firmas.url_doctor,
          firmDoctorSupport: firmDoctorSupportGet
        })
      }
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  handlerModalProcedure = () => {
    this.setState({ modalProcedures: !this.state.modalProcedures });
  }

  handlerModalConsult = () => {
    this.setState({ modalConsult: !this.state.modalConsult });
  }

  handlerModalLabs = () => {
    this.setState({ modalLabs: !this.state.modalLabs });
  }

  handlerModalIncapacity = () => {
    this.setState({ modalIncapacity: !this.state.modalIncapacity });
  }

  handlerObservation = (observation) => {
    this.setState({ observation: observation });
  };

  handlerFormulasManager = (formula) => {
    var formulas = this.state.formulas;
    formulas.push(formula);
    this.setState({ formulas: formulas });
  }

  handlerMedicationsObservations = (medicationsObservations) => {
    this.setState({ medicationsObservations: medicationsObservations });
  };

  handlerDosis = (dosis) => {
    this.setState({ dosis: dosis });
  }

  handlerFrequence = (freq) => {
    this.setState({ frequence: freq });

    switch (freq) {
      case "Dos veces al día":
        this.setState({ frequenceVal: 2 });
        break;
      case "Tres veces al día":
        this.setState({ frequenceVal: 3 });
        break;
      case "Cuatro veces al día":
        this.setState({ frequenceVal: 4 });
        break;
      default:
        this.setState({ frequenceVal: 1 });
        break;
    }

  };

  handlerDuration = (dur) => {

    let valor = (this.state.dosis * this.state.frequenceVal) * dur;
    this.setState({ duration: dur, cantidadMedicamentes: valor });
  }

  handlerCant = (cant) => {
    this.setState({ cantidadMedicamentes: cant });
  }

  makePdfYodo = async () => {

    await this.loadDataFirm()

    const data = {
      urlLogo: this.state.urlLogo,
      profile: this.state.profile,
      admissions: this.state.admissions,
      names: this.state.infoPaciente.nombres + " " + this.state.infoPaciente.ape1 + " " + this.state.infoPaciente.ape2,
      typeOfDocument: this.state.infoPaciente.tipDoc,
      documentNumber: this.state.infoPaciente.numDoc,
      age: calculateAgeParse(this.state.infoPaciente.f_nac),
      birthday: this.state.infoPaciente.f_nac,
      gender: this.state.infoPaciente.sexo,
      address: this.state.infoPaciente.direccion.direccion,
      city: this.state.infoPaciente.direccion.ciudad,
      cellphone: this.state.infoPaciente.telefono1,
      entity: this.state.infoPaciente.third_info.nombre,
      regimen: this.state.infoPaciente.contrato.nom_regimen,
      exam: this.state.infoPaciente.servicios.servicios[0].nombre,
      medicoApoyo: this.state.medicoApoyo,
      firmDoctor: this.state.firmDoctor,
      firmDoctorSupport: this.state.firmDoctorSupport,
      nombre_medicamento: this.state.infoPaciente?.nombre_medicamento,
      dosis_medicamento: this.state.infoPaciente?.dosis_medicamento,
      id_admision_actual: this.state.infoPaciente?.admision
    };


    this.setState({ modalYodo: true });
    pdfYodo(data);
  }

  addMoreDiagnostics = (services) => {
    console.log({ services })
    let addedDiagnostics = this.state.addedDiagnostics;
    let newAddedDignostics = [];
    let duplicatedServices = [];
    console.log(this.state.addedDiagnostics);
    for (let i = 0; i < services.length; i++) {
      const elementServiceToAdd = services[i];
      console.log({ elementServiceToAdd });
      let isAlreadyInAddedServices = this.props.MedicalOrders.addedDiagnostics.find(serv => serv.cupscod.toString() === elementServiceToAdd.cupscod.toString());
      console.log({ isAlreadyInAddedServices });
      if (!isAlreadyInAddedServices) {
        newAddedDignostics.push(elementServiceToAdd);
      } else {
        duplicatedServices.push(elementServiceToAdd);
      }
    }
    let alertRepeatedServices = duplicatedServices.reduce((acc, cur, idx) => duplicatedServices.length === idx + 1 ? acc + cur.cupscod + ' ' + cur.cupsnom : acc + cur.cupscod + ' ' + cur.cupsnom + '\n', '')
    console.log({ alertRepeatedServices })
    if (!!duplicatedServices.length) alert(`Ya se incluyeron los siguientes diagnosticos:\n${alertRepeatedServices}`);
    this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""], countDiagnostic: this.state.countDiagnostic + 1 }, () => this.props.addDiagnostic(newAddedDignostics));
  }

  createFormula = () => {

    console.log(this.state.medicament.length);

    if (this.state.medicament.length === 0 || this.state.dosis === 0 || this.state.duration === 0 || this.state.frequence === "") {
      //alert("Ingresa todos los datos de la formula"); 
      this.setState({ modalOpen: true });
    } else {
      let formula = {
        activePrinciple: this.state.medicament.principioactivo,
        concentration: this.state.medicament.cantidad + this.state.medicament.unidadmedida,
        pharmaceuticalForm: this.state.medicament.formafarmaceutica,
        route: this.state.medicament.viaadministracion,
        dose: this.state.dosis,
        frequency: this.state.frequence,
        duration: this.state.duration,
        units: this.state.cantidadMedicamentes
      };

      this.props.handlerFormulasNew(formula, this.props.reset);
      this.setState({ medicament: [] }, () => {
        if (this.state.medicament.length === 0)
          this.setState({ dosis: '', duration: 0, cantidadMedicamentes: '', principioactivo: '', frequence: '', viaadministracion: '', cantidad: '', formafarmaceutica: '' });
      })
    }
  }

  handlerTotalUnities = () => {

    let valor = (this.state.dosis * this.state.frequenceVal) * this.state.duration;
    //console.log(valor);
    this.setState({ total: valor });

  }


  render() {
    const dataMedicalOrders = {
      tableHeaderData: [{
        Header: 'Codigo',
        accessor: 'codigo',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'Nombre',
        accessor: 'nombre',
      },
      ],
      tableRowsData: this.props.MedicalOrders.addedDiagnostics
    };

    const dataFormula = {
      tableHeaderData: [
        {
          Header: 'PRINCIPIO ACTIVO',
          accessor: 'activePrinciple',
          disableGlobalFilter: true,
          width: 65,
        },
        {
          Header: 'CONCENTRACION',
          accessor: 'concentration',
        },
        {
          Header: 'FORMA FARMACEUTICA',
          accessor: 'pharmaceuticalForm',
        },
        {
          Header: 'VIA DE ADMINISTRACION',
          accessor: 'route',
        },
        {
          Header: 'DOSIS',
          accessor: 'dose',
        },
        {
          Header: 'FRECUENCIA',
          accessor: 'frequency',
        },
        {
          Header: 'DURACION',
          accessor: 'duration',
        },
        {
          Header: 'UNIDADES',
          accessor: 'units',
        }
      ],
      tableRowsData: /* this.props.MedicalOrders.formulas */ this.state.dataToTableFormula
    };

    const reactTableMedicaments = {
      tableHeaderData: [{
        Header: 'Principio activo',
        accessor: 'principioactivo',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'Producto',
        accessor: 'producto',
      },
      {
        Header: 'Forma Farmacéutica',
        accessor: 'formafarmaceutica',
      },
      {
        Header: 'Codigo',
        accessor: 'atc',
      },
      ],
      tableRowsData: this.state.dataMedicaments
    };

    const reactTableFoundDiagnostics = {
      tableHeaderData: [{
        Header: 'Codigo',
        accessor: 'cupscod',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'Nombre',
        accessor: 'cupsnom',
      },
      ],
      tableRowsData: this.state.dataDiagnostic
    }

    return (
      <Fragment>
        <Col md={12} sm={12}>
          <div className={"container-wraper-hc"}>
            {!this.props.MedicalOrders.load ?
              <>
                <Row>
                  <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                    <div className="title-clinic-history">
                      <h4>Procedimientos y Servicios</h4>
                    </div>
                    <div className='icons-top--medical-exams'>
                      <div>
                        <h5 className='common-label-section-others'>Procedimientos</h5>
                        <Button
                          color="primary"
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                          onClick={() => {
                            this.setState({ modalProcedures: true });
                          }}
                        >
                          <FontAwesomeIcon icon={faNotesMedical} style={{ color: 'gray' }} />
                        </Button>
                      </div>
                      <div style={{ marginLeft: 15 }} >
                        <h5 className='common-label-section-others'>Examenes</h5>
                        <Button
                          color="primary"
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                          onClick={() => {
                            this.setState({ modalLabs: true });
                          }}
                        >
                          <FontAwesomeIcon icon={faVial} style={{ color: 'gray' }} />
                        </Button>
                      </div>
                      <div style={{ marginLeft: 15 }} >
                        <h5 className='common-label-section-others'>Consultas</h5>
                        <Button
                          color="primary"
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                          onClick={() => {
                            this.setState({ modalConsult: true });
                          }}
                        >
                          <FontAwesomeIcon icon={faStethoscope} style={{ color: 'gray' }} />
                        </Button>
                      </div>

                      <div style={{ marginLeft: 50 }} >
                        <h5 className='common-label-section-others'>Incapacidad</h5>
                        <Button
                          color="primary"
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                          onClick={() => {
                            this.setState({ modalIncapacity: true });
                          }}
                        >
                          <FontAwesomeIcon icon={faHospitalUser} style={{ color: 'gray' }} />
                        </Button>
                      </div>

                      <div style={{ marginLeft: 50 }} >
                        <h5 className='common-label-section-others'>Certificado yodo</h5>
                        <Button
                          color="primary"
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                          onClick={() => {
                            this.makePdfYodo()
                          }}
                        >
                          <FontAwesomeIcon icon={faHospitalUser} style={{ color: 'gray' }} />
                        </Button>

                      </div>

                      <div style={{ marginLeft: 50 }} >
                        <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} >Buscar </span>
                        <Button
                          color="primary"
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                          disabled={this.props.isCloseClinicHistory}
                          onClick={() => {

                            this.setState({ openModal: !this.state.openModal });
                          }}
                        >
                          <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                        </Button>
                      </div>


                    </div>
                    {this.state.modalProcedures ? <ProceduresModal data={this.state.proceduresList} openModal={this.state.modalProcedures} setOpenModal={this.handlerModalProcedure} addDiagnostic={this.addMoreDiagnostics} disabledForm={this.props.isCloseClinicHistory} /> : null}
                    {this.state.modalConsult ? <ConsulationModal data={this.state.consultList} openModal={this.state.modalConsult} setOpenModal={this.handlerModalConsult} addDiagnostic={this.addMoreDiagnostics} disabledForm={this.props.isCloseClinicHistory} /> : null}
                    {this.state.modalLabs ? <LabsModal data={this.state.labList} openModal={this.state.modalLabs} setOpenModal={this.handlerModalLabs} addDiagnostic={this.addMoreDiagnostics} disabledForm={this.props.isCloseClinicHistory} /> : null}
                    {this.state.modalIncapacity ? <MedicalIncapacity data={this.props.data} openModal={this.state.modalIncapacity} setOpenModal={this.handlerModalIncapacity} disabledForm={this.props.isCloseClinicHistory} profesional={this.props.profesional}
                      infoAdmission={this.props.infoAdmission} thirdInfo={this.props.thirdInfo} diagnostic={this.props.diagnostic} /> : null}

                  </div>
                </Row>
                <Row>
                  <div className="table-medicine-add">
                    <table className="table table--bordered" >
                      <thead className="thead th">
                        <tr className="react-table thead tr">
                          <th style={{ maxWidth: 50, columnGap: 5 }}>
                            <Header column="CUPS" />
                          </th>
                          <th style={{ maxWidth: 400, columnGap: 5 }}>
                            <Header column="DESCRIPCIÓN" />
                          </th>
                          <th style={{ maxWidth: 200, columnGap: 5 }}>
                            <Header column="CANTIDAD" />
                          </th>
                          <th style={{ maxWidth: 200, columnGap: 5 }}>
                            <Header column="OBSERVACIÓN" />
                          </th>
                          <th style={{ maxWidth: 100, columnGap: 5 }}>
                            <Header column="ACCIÓN" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.MedicalOrders.addedDiagnostics.map((diagnostic, index) => {
                          return <tr key={index}>
                            <td>{diagnostic.cupscod}</td>
                            <td style={{ maxWidth: 400, padding: '0.5em 1em' }}>{diagnostic.cupsnom}</td>
                            <td ><TextField
                              type="number"
                              className="material-form__field"
                              value={this.props.MedicalOrders.amount[index]}
                              disabled={this.props.isCloseClinicHistory}
                              defaultValue="1"
                              onChange={(e) => {
                                let cantidad = this.state.amount;
                                cantidad[index] = e.target.value;
                                this.setState({ amount: cantidad });
                                this.props.handlerAmountExams(index, e.target.value);
                              }}
                            />  </td>
                            <td ><TextField
                              type="text"
                              className="material-form__field"
                              value={this.props.MedicalOrders.observations[index]}
                              disabled={this.props.isCloseClinicHistory}
                              onChange={(e) => {
                                var observations = this.state.observations;
                                observations[index] = e.target.value;
                                this.setState({ observations: observations });
                                this.props.addObservation(index, e.target.value);
                              }}
                            />  </td>
                            {/* <td>
                              <div className="form">
                                <div className="form__form-group">
                                  <div className="form__form-group-field" style={{ marginTop: '0.5em' }}>
                                    <textarea
                                      rows='2'
                                      style={{ minHeight: 35 }}
                                      name={`observation-${index}`}
                                      type="text"
                                      value={this.state.observations[index]}
                                      disabled={this.props.isCloseClinicHistory}
                                      onChange={(e) => {
                                        var observations = this.state.observations;
                                        observations[index] = e.target.value;
                                        this.setState({ observations: observations });
                                        this.props.addObservation(index, e.target.value);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td> */}
                            <td style={{ marginLeft: 10 }}>
                              <Tooltip title="Eliminar"
                                disabled={this.props.isCloseClinicHistory}
                              >
                                <IconButton
                                  onClick={() => {
                                    var data = this.state.addedDiagnostics;
                                    data = data.filter((value, indexDiag) => {
                                      return indexDiag !== index;
                                    });
                                    var observations = this.state.observations;
                                    observations = observations.filter((value, indexDiag) => {
                                      return indexDiag !== index;
                                    });
                                    let amountProcCon = this.state.amount;
                                    amountProcCon = amountProcCon.filter((value, indexDiag) => {
                                      return indexDiag !== index;
                                    });
                                    console.log(data);
                                    console.log(index);
                                    this.setState({ addedDiagnostics: data, observations: observations, amount: amountProcCon, countDiagnostic: this.state.countDiagnostic - 1 }, () => {
                                      this.props.removeDiagnostic(index);
                                    })
                                  }}
                                >
                                  <DeleteForeverIcon />
                                </IconButton>
                              </Tooltip>
                            </td>
                          </tr>
                        })}
                      </tbody>
                    </table>
                  </div>
                </Row>
                <Row>
                  <div className="form">
                    <div className="form__form-group" style={{ marginTop: 10 }}>
                      <span className='common-label-section-others'>Observaciones Procedimientos y Servicios</span>
                      <div className="form__form-group-field">
                        <textarea
                          name="textarea-observations-exams"
                          value={this.props.MedicalOrders.observationAndProcedure}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(e) => { this.props.handlerObservationAndProcedureTextMedicalOrder(e.target.value); }}
                        >
                        </textarea>
                      </div>
                    </div>
                  </div>
                </Row>
                {/* <Row>
                <div className="form__form-group" style={{ width: 500, minWidth: 250 }}>
                  <div className="card__title">
                    <h5 className="bold-text">Medicamentos</h5>
                  </div>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} >Buscar Medicamentos</span>
                  <Tooltip title="Buscar"
                    disabled={this.props.isCloseClinicHistory}
                  >
                    <IconButton
                      color="primary"
                      disabled={this.props.isCloseClinicHistory}
                      onClick={() => {
                        this.setState({ openMedicaments: !this.state.openMedicaments });
                      }}
                    >
                      <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                    </IconButton>
                  </Tooltip>
                </div>
              </Row>
              <Row>
                <div className="table-medicine-add">
                  <table className="table table--bordered" >
                    <thead>
                      <tr>
                        <td >Principio Activo - Denominación Común Internacional </td>
                        <td >Concentración </td>
                        <td >Forma Farmacéutica </td>
                        <td >Vía de Administración </td>
                        <td >Dosis </td>
                        <td >Frecuencia </td>
                        <td >Duración (Días) </td>
                        <td > Cantidad </td>
                        <td > </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td ><TextField
                          type="text"
                          className="material-form__field"
                          style={{ width: 350 }}
                          value={this.state.principioactivo}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(event) => {
                            this.setState({ principioactivo: event.target.value });
                          }}
                        /> </td>
                        <td ><TextField
                          type="text"
                          className="material-form__field"
                          style={{ width: 100 }}
                          value={this.state.cantidad}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(event) => {
                            this.setState({ cantidad: event.target.value });
                          }}
                        />  </td>
                        <td ><TextField
                          type="text"
                          className="material-form__field"
                          style={{ width: 200 }}
                          value={this.state.formafarmaceutica}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(event) => {
                            this.setState({ formafarmaceutica: event.target.value });
                          }}
                        />  </td>
                        <td ><TextField
                          type="text"
                          className="material-form__field"
                          style={{ width: 150 }}
                          value={this.state.viaadministracion}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(event) => {
                            this.setState({ viaadministracion: event.target.value });
                          }}
                        /> </td>
                        <td ><TextField
                          required
                          type="number"
                          className="material-form__field"
                          style={{ width: 80 }}
                          value={this.state.dosis}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(event) => {
                            this.handlerDosis(event.target.value);
                          }}
                        />  </td>
                        <td ><TextField
                          className="material-form__field"
                          style={{ width: 180, }}
                          select
                          disabled={this.props.isCloseClinicHistory}
                          value={this.state.frequence}
                          onChange={(event) => {
                            this.handlerFrequence(event.target.value);
                          }}
                        >
                          <MenuItem className="material-form__option" key={0} value={'Una vez al día'}>Una vez al día</MenuItem>
                          <MenuItem className="material-form__option" key={1} value={'Dos veces al día'}>Dos veces al día</MenuItem>
                          <MenuItem className="material-form__option" key={2} value={'Tres veces al día'}>Tres veces al día</MenuItem>
                          <MenuItem className="material-form__option" key={3} value={'Cuatro veces al día'}>Cuatro veces al día</MenuItem>
                          <MenuItem className="material-form__option" key={4} value={'Dos veces a la semana'}>Dos veces a la semana</MenuItem>
                          <MenuItem className="material-form__option" key={5} value={'Cada mes'}>Cada mes</MenuItem>
                          <MenuItem className="material-form__option" key={6} value={'Cada dos meses'}>Cada dos meses</MenuItem>
                          <MenuItem className="material-form__option" key={7} value={'Cada seis meses'}>Cada seis meses</MenuItem>
                          <MenuItem className="material-form__option" key={8} value={'Dosis unica'}>Dosis unica</MenuItem>
                        </TextField> </td>
                        <td ><TextField
                          required
                          type="number"
                          className="material-form__field"
                          style={{ width: 100 }}
                          value={this.state.duration}
                          disabled={this.props.isCloseClinicHistory}
                          onChange={(event) => {
                            this.handlerDuration(event.target.value);
                          }}
                        />  </td>
                        <td > <TextField
                          required
                          type="number"
                          className="material-form__field"
                          style={{ width: 80 }}
                          disabled={this.props.isCloseClinicHistory}
                          value={this.state.cantidadMedicamentes}
                          onChange={(event) => {
                            this.handlerCant(event.target.value);
                          }}
                        /></td>
                        <td >
                          <Tooltip title="Agregar"
                            disabled={this.props.isCloseClinicHistory}
                          >
                            <IconButton
                              color="primary" onClick={() => {
                                this.createFormula();
                              }}>
                              <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Row> */}
                {/*  <Row>
                <div className="table-medicine-add">
                  <DataReactTable
                    title=""
                    reactTableData={dataFormula}
                    config={{
                      withPagination: true,
                      withSearchEngine: false,
                      isSortable: false,
                      isEditable: true,
                      watchCustomMenu: false
                    }}
                    disabledTextFields={this.props.isCloseClinicHistory}
                    ReactTableActions={ReactTableActionsFormula}
                    refresh={this.props.loadMedicalOrders}
                    Callback={() => {
                      var data = this.state.formulas;
                      data.pop();
                      this.setState({ formulas: data }, () => {
                        this.props.removeFormula();
                      });
                    }}
                  />
                </div>
              </Row> */}
                {/* <Row>
                <div className="form">
                  <div className="form__form-group" style={{ marginTop: 10 }}>
                    <span className="form__form-group-label">Observaciones Medicamentos</span>
                    <div className="form__form-group-field">
                      <textarea
                        name="textarea-medications-observations"
                        value={this.props.MedicalOrders.medicalObservation}
                        disabled={this.props.isCloseClinicHistory}
                        onChange={(e) => {
                          this.props.handlerMedicalObservationTextMedicalOrder(e.target.value)
                        }}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </Row> */}

                <SearchModalCUPS
                  openModalCUPS={this.state.openModal}
                  closeModalCUPS={() => {
                    this.setState({ openModal: false });
                  }}
                  Callback={(diagnostic) => {
                    this.props.selectDiagnostic(diagnostic);
                    var diagnosticNew = diagnostic;
                    this.setState({ loadAddedDiagnostics: true }, () => {

                      var addedDiagnostics = this.state.addedDiagnostics;
                      if (!addedDiagnostics.includes(diagnosticNew)) {
                        addedDiagnostics.push(diagnosticNew);
                        this.setState({ codigo: "", nombre: "" });
                      } else {
                        alert("Ya se incluyo este diagnostico");
                      }
                      this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""], loadAddedDiagnostics: false, countDiagnostic: this.state.countDiagnostic + 1 }, () => {
                        this.props.addDiagnostic(diagnosticNew);
                      });
                    })
                  }}
                />

                <SearchModalMedicines
                  openModalMedicine={this.state.openMedicaments}
                  closeModalMedicine={() => {
                    this.setState({ openMedicaments: false })
                  }}
                  Callback={(medicament) => {
                    console.log(medicament);
                    this.setState({
                      medicament: medicament, openMedicaments: false,
                      principioactivo: medicament.principioactivo, viaadministracion: medicament.viaadministracion,
                      formafarmaceutica: medicament.formafarmaceutica, cantidad: medicament.cantidad + medicament.unidadmedida
                    });
                  }}
                />

              </>
              : null}
            <ModalTheme
              color={'danger'}
              title={"Error"}
              message={"Ingresa todos los datos de la formula"}
              modal={this.state.modalOpen}
              toggle={() => { this.setState({ modalOpen: !this.state.modalOpen }); }}
              onOk={() => { this.setState({ modalOpen: !this.state.modalOpen }); }} />
          </div>
        </Col>
        {this.state.modalYodo ?
          <Modal
            open={this.state.modalYodo}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
          >
            <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
              <IconButton style={{ float: 'right' }} onClick={() => {
                this.setState({ modalYodo: false });
              }}>
                <CloseIcon />
              </IconButton>
              <div className='container-pdfs-modal'>
                <iframe className='iframe-pdfs' id="pdfV" title="pdf-report" >
                </iframe>
              </div>
            </div>
          </Modal>
          : null}
      </Fragment>);
  }
}

export default reduxForm({
  form: `medical-orders-form`, // a unique identifier for this form
})(withTranslation('common')(MedicalOrders));